import { useSyncExternalStore } from "react";
import {
  readAutoSearchPref,
  subscribeMapAutoSearchPref,
} from "@/features/search/search-map/search-area-button";
import { DEFAULT_LOCATION_LABEL } from "./recent-search-utils";

function formatSearchBarLocationLabel(
  location: string | null | undefined,
  mapAutoSearch: boolean,
): string {
  const trimmed = location?.trim();
  if (trimmed) return trimmed;
  if (mapAutoSearch) return "Map area";
  return DEFAULT_LOCATION_LABEL;
}

function useMapAutoSearchPref(): boolean {
  return useSyncExternalStore(subscribeMapAutoSearchPref, readAutoSearchPref, () => false);
}

export { formatSearchBarLocationLabel, useMapAutoSearchPref };
